import {getDept, getPatientInfo, getClinicForRegist, order} from '@/api/registered'
import store from '@/store'
import { message } from 'ant-design-vue'
const state = {
    patient: {},
    current: 0,//挂号步奏号，默认处于第一步状态
    steps: [
        {title: '科室', description: '选择科室'},
        {title: '排班', description: '选择号别'},
        {title: '挂号', description: '正在挂号'},
        {title: '完成', description: '挂号完成'},
    ],
    depts: '',
    deptType: '',
    scheduling: '',
    schedulingInfo: ''
}
const mutations = {
    ADD_PATIENT(state, patient){
        for (let key in patient){
            state.patient[key] = patient[key];
        }
    },
    SET_DEPTS(state, depts){
        state.depts = depts;
    },
    SET_DEPTTYPE(state, deptType){
        state.deptType = deptType;
    },
    SET_CURRENT(state, current){
        state.current = current;
    },
    ADD_CURRENT(state){
        state.current++;
    },
    REDUCE_CURRENT(state, value){
        if(value){
            state.current = 0;
        }else{
            state.current--;
        }
    },
    SET_SCHEDULING(state, scheduling){
        state.scheduling = scheduling;
    },
    SET_SCHEDULINGINFO(state, schedulingInfo){
        state.schedulingInfo = schedulingInfo;
    },
}
const actions = {
    addPatientInfo({ commit }, paramData){
        commit('ADD_PATIENT', paramData.values);
    },
    /**
     * 获取当前登录患者信息
     * @param {*} param0 
     */
    getPatientInfo({ commit }){
        return new Promise((resolve) => {
            getPatientInfo().then( result => {
                // console.log("获取到的患者信息:", result);
                commit('ADD_PATIENT', result);
                resolve();
            }).catch( (error) => {
                message.error({
                    content: () => '未获取到患者信息！' + error.message,
                    class: 'custom-class',
                    style: {
                        marginTop: '20vh',
                    },
                    duration: 2
                });
            });
        });
    },
    /**
     * 获取科室信息
     * @param {*} param0 
     * @param {*} paramData 
     * @returns 
     */
    getDept({ commit }, paramData){
        return new Promise((resolve) => {
            getDept(paramData.values).then((result)=>{
                
                let data = result;
                // console.log("得到科室信息：", data);
                let deptMap = new Map();
                let deptType = [];
                data.forEach((item) => {
                    if(deptMap.get(item.internalOrSergeryCode)){
                        deptMap.get(item.internalOrSergeryCode).push(item);
                    }else{
                        let deptList = [];
                        deptList.push(item);
                        deptMap.set(item.internalOrSergeryCode, deptList);
                        deptType.push({
                            code: item.internalOrSergeryCode,
                            name: item.internalOrSergery,
                            icon: 'bed-pulse'
                        });
                    }
                });
                commit('SET_DEPTS', deptMap);
                commit('SET_DEPTTYPE', deptType);
                resolve();
            }).catch((error) => {
                message.error({
                    content: () => '未获取到科室信息信息！ ' + error.message,
                    class: 'custom-class',
                    style: {
                        marginTop: '20vh',
                    },
                    duration: 2
                });
            });
        });
    },
    /**
     * 排班信息
     * @param {*} param0 
     * @param {*} data 
     * @returns 
     */
    getClinicForRegist({ commit }, paramData){
        let data = {
            deptCode: state.patient.deptCode,
            beginDate: paramData.values.date,
            endDate: paramData.values.date
        }
        // console.log("获取排班信息：", data);
        return new Promise((resolve) => {
            getClinicForRegist(data).then( result => {
                // console.log("获取到的排班信息:", result);
                let map = new Map();
                let list = [];
                result.forEach((item) => {
                    if(map.get(item.doctorId)){
                        map.get(item.doctorId).push(item);
                    }else{
                        let list1 = [];
                        list1.push(item);
                        map.set(item.doctorId, list1);
                        list.push(item);
                    }
                });
                commit('SET_SCHEDULING', list);
                commit('SET_SCHEDULINGINFO', map);
                resolve();
            }).catch( (error) => {
                message.error({
                    content: () => '未获取到排班信息！ ' + error.message,
                    class: 'custom-class',
                    style: {
                        marginTop: '20vh',
                    },
                    duration: 2
                });
            });
        });
    },
    /**
     * 挂号
     * @param {*} param0 
     * @returns 
     */
    order({ commit }){
        let data = {
            schId: state.patient.schId,
            visitDate: state.patient.visitDate,
            patientId: state.patient.patientId,
            idNo: state.patient.idNo,
            phone: state.patient.phone,
            doctorId: state.patient.doctorId,
            clinicTimePrompt: state.patient.clinicTimePrompt,//state.patient.clinicTimePrompt
            deptCode: state.patient.deptCode,
            timeDesc: state.patient.timeDesc
        }
        // console.log("预约请求后端接口：", data);
        return new Promise((resolve) => {//, reject
            order(data).then( result => {
                // console.log("挂号：", result);
                commit('ADD_PATIENT', result);
                store.dispatch({type: 'error/setError',
                 values: {
                    code: '',
                    message: "挂号成功",
                    status: "success"
                }});
                resolve();
            }).catch( (error) => {
                commit('SET_CURRENT', -1);
                store.dispatch({type: 'error/setError', 
                    values: {
                            code: error.code,
                            message: error.message,
                            status: "error",
                            path: '/registered'
                    }});
            });
        });
    },
    /**
     * 预约挂号： 下一步
     * @param {*} param0 
     */
    addCurrent({ commit }){
        commit('ADD_CURRENT');
    },

    /**
     * 预约挂号：上一步
     * @param {*} param0 
     */
    reduceCurrent({ commit }, value){
        commit('REDUCE_CURRENT', value);
    }
}
export default{
    namespaced: true,//用于全局引用此文件里的方法时标识这个文件名，解决命名冲突问题
    state,
    mutations,
    actions
}